import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { LocationDescriptor } from 'history';

interface Props extends RouteComponentProps {
    to: LocationDescriptor;
    children?: React.ReactChildren | React.ReactChild | React.ReactNode;
}

const HashLink = (props: Props) => {
    const { to, children, staticContext, ...rest} = props;
    return (
        <Link to={`${props.to}${props.location.hash}`} {...rest}>{props.children}</Link>
    )
};

export default withRouter(HashLink);


// WEBPACK FOOTER //
// ./src/components/Common/HashLink.tsx